import { Link } from 'react-router-dom';
import { FileText, Clock } from 'lucide-react';

export function TemplatesPage() {
  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold text-navy mb-2">תבניות תיק פנימי</h1>
      <p className="text-slate-600 mb-8">
        תבניות מוכנות למסמכי מו״מ מול בנקים — Term Sheet, תיק אשראי, מכתב הצעה.
      </p>

      <div className="card text-center py-16">
        <div className="w-14 h-14 mx-auto rounded-full bg-amber-50 flex items-center justify-center mb-4">
          <Clock className="w-7 h-7 text-amber-600" />
        </div>
        <h2 className="text-xl font-semibold text-navy mb-2">בקרוב — Phase 2</h2>
        <p className="text-sm text-slate-600 max-w-md mx-auto mb-6">
          מחולל PDF עם תבניות ניתנות להתאמה, כולל מיתוג משרד היועץ ושילוב
          אוטומטי של ממצאי הניתוח מהקייסים הפתוחים.
        </p>

        <div className="inline-flex flex-col items-start gap-2 text-sm text-slate-600 bg-slate-50 rounded-lg p-4 text-right">
          <PlannedItem>תבנית Term Sheet בעברית ואנגלית</PlannedItem>
          <PlannedItem>תיק אשראי מלא עם ניתוח DSCR ותחזיות</PlannedItem>
          <PlannedItem>מכתב הצעה ללקוח — סיכום תנאים ממאגר הבנקים</PlannedItem>
          <PlannedItem>ייצוא PDF עם חתימה דיגיטלית</PlannedItem>
        </div>

        <Link to="/business" className="inline-block mt-8 text-business-primary hover:underline text-sm">
          חזרה ללוח הבקרה
        </Link>
      </div>
    </div>
  );
}

function PlannedItem({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex items-center gap-2">
      <FileText className="w-4 h-4 text-slate-400 flex-shrink-0" />
      <span>{children}</span>
    </div>
  );
}
